<template>
  <div class="login limiter">
    <div
      class="container-login100"
      v-bind:class="{ 'ui loading segment': processing }"
    >
      <div class="wrap-login100" ref="loading_target">
        <div class="login100-form-title" :style="style">
          <span class="login100-form-title-1">&nbsp;</span>
        </div>
        <div class="login100-form validate-form" id="login_form">
          <div
            class="wrap-input100 validate-input m-b-18"
            v-bind:class="{ hidden: config && config.hide_enterprise_field }"
          >
            <span class="label-input100">{{ $t("enterprise") }}</span>
            <input
              class="input100"
              type="text"
              name="enterprise"
              v-bind:placeholder="$t('enterprise')"
              v-model="value.enterprise"
            />
            <span class="focus-input100"></span>
          </div>
          <div class="wrap-input100 validate-input m-b-18">
            <span class="label-input100">{{ $t("username") }}</span>
            <input
              class="input100"
              type="text"
              name="username"
              v-bind:placeholder="$t('username')"
              v-model="value.username"
            />
            <span class="focus-input100"></span>
          </div>
          <div class="wrap-input100 validate-input m-b-18">
            <span class="label-input100">{{ $t("password") }}</span>
            <input
              class="input100"
              type="password"
              name="password"
              v-bind:placeholder="$t('password')"
              v-model="value.password"
            />
            <span class="focus-input100"></span>
          </div>
          <div class="container-login100-form-btn" style="width:100%">
            <button
              class="login100-form-btn"
              type="submit"
              style="width: 100%;"
              v-on:click="$emit('do_auth')"
            >
              {{ $t("sign in") }}
            </button>
          </div>
          <language-login-selector
            style="max-width:unset !important; width: 100%; margin-top:20px"
          />
        </div>
        <div
          class="ui error message"
          v-if="error"
          v-html="error"
          style="margin: 0px 80px 40px 80px; padding: 20px;"
        >
          <p></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageLoginSelector from "@/components/LanguageLoginSelector";
import { api_host } from "@/utils";

export default {
  name: "LoginSmartphoneView",
  components: { LanguageLoginSelector },
  data() {
    return {
      // enterprise: "",
      // username: "",
      // password: "",
    };
  },
  props: {
    value: {
      type: Object,
      default: function() {
        return {};
      },
    },
    error: {
      type: String,
    },
    config: {
      type: Object,
    },
    processing: {
      type: Boolean,
    },
  },
  computed: {
    style() {
      if (this.config.logo) {
        return (
          "background-image: url('" +
          api_host +
          "/public/uploads/logo/" +
          this.config.logo +
          "'); height: 75px;"
        );
      } else {
        return "background-image: url('images/backgrounds/Modul-12.png'); height: 75px; padding: 50px";
      }
    },
  },
  watch: {
    // enterprise() {
    //   this.$emit("input", {
    //     enterprise: this.enterprise,
    //     username: this.username,
    //     password: this.password,
    //   });
    // },
    // username() {
    //   this.$emit("input", {
    //     enterprise: this.enterprise,
    //     username: this.username,
    //     password: this.password,
    //   });
    // },
    // password() {
    //   this.$emit("input", {
    //     enterprise: this.enterprise,
    //     username: this.username,
    //     password: this.password,
    //   });
    // },
  },
};
</script>
